import { Stack, Typography } from '@mui/material';
import { AddNewIntegrationAnimatedText } from './AddNewIntegrationAnimatedText';
import { AddNewIntegrationButton } from './AddNewIntegrationButton';
import { ManageUnifiedFieldButton } from './ManageUnifiedFieldButton';

export const IntegrationsHeader = () => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        px: 3.5,
        py: 2,
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Typography variant="h4">Integrations</Typography>
      <Stack direction="row-reverse" spacing={2} alignItems="flex-end">
        <Typography variant="subtitle2" width={220}>
          Integrate with
          <AddNewIntegrationAnimatedText />
          <Typography variant="subtitle2">+30 more</Typography>
        </Typography>
        <AddNewIntegrationButton />
        <ManageUnifiedFieldButton />
      </Stack>
    </Stack>
  );
};
